// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3nL-r","row":"styles_row__2T-1X","price":"styles_price__2Tra9","bold":"styles_bold__2d__d"};